export default __webpack_public_path__ + "static/media/csvFileIcon.3c424265.svg";